// Los botones de Tienda online, con los colores de Atlas —
// ADR-2026-10-05-los-botones-de-la-tienda-son-de-atlas.
//
// El módulo usaba negro (`bg-brand-black`) para la acción principal y botones con
// solo borde para el resto: sobre el gris de la pantalla se leían como texto con un
// recuadro, no como botones. Ahora la principal es el azul de la marca y las demás
// tienen fondo: azul suave la que acompaña, rojo suave la que borra. Viven acá para
// que las pantallas del módulo no vuelvan a divergir.
//
// Los azules van en hex y no como `brand-primary/10`: los tokens `brand-*` no
// tienen `<alpha-value>` y el modificador de opacidad no genera CSS.

const base =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-40';

const tamano = {
  normal: 'rounded-xl py-2.5 px-5 text-sm',
  chico: 'rounded-lg py-1.5 px-3 text-xs',
};

const tono = {
  /** La acción de la pantalla: Publicar, Crear, Elegir creaciones. Una por pantalla. */
  primario: 'bg-brand-primary text-white shadow-sm hover:bg-brand-primary-hover',
  /** Acompaña a la principal: Categorías, Completar con IA, Modificar. */
  secundario: 'bg-[rgb(var(--brand-primary-rgb)_/_0.07)] text-brand-primary hover:bg-[rgb(var(--brand-primary-rgb)_/_0.125)]',
  /** Salir sin hacer nada: Cancelar. */
  neutro: 'bg-neutral-100 text-brand-black hover:bg-neutral-200',
  /** Borra o saca algo. */
  peligro: 'bg-red-50 text-red-600 hover:bg-red-100',
  /**
   * Sobre un fondo ya teñido (la barra de lo tildado): blanco con borde. El azul suave
   * de `secundario` sobre el celeste de la barra casi no se veía.
   */
  contorno: 'bg-white text-brand-primary shadow-sm ring-1 ring-[rgb(var(--brand-primary-rgb)_/_0.2)] hover:bg-[rgb(var(--brand-primary-rgb)_/_0.07)]',
  /** `peligro` sobre un fondo teñido. */
  contornoPeligro: 'bg-white text-red-600 shadow-sm ring-1 ring-red-200 hover:bg-red-50',
};

export type TonoDeBoton = keyof typeof tono;

/** Las clases de un botón del módulo. `extra` suma layout (ancho, margen), no color. */
export function boton(t: TonoDeBoton, opciones: { chico?: boolean; extra?: string } = {}): string {
  return [base, opciones.chico ? tamano.chico : tamano.normal, tono[t], opciones.extra ?? ''].join(' ').trim();
}
